import config from '../config';
import { BuildData } from './depot';

export enum BranchType {
    rmb = 'rmb',
    actor = 'actor',
}

export class AssignBuild {
    branchType: string = '';
    buildId: string = '';
    assignDate: number = 0;
    buildData: BuildData = new BuildData();
}

export class BranchData {
    description: string = '';
    createDate: number = 0;
    gameId: string = '';
    branchName: string = '';
    assignBuilds: any;
}

export const createBranch = async (
    license: string,
    desc: string,
    branchName: string,
    token?: string,
): Promise<BranchData | undefined> => {
    const resp = await fetch(`${config.entityManagerURL}/game/${license}/branches`, {
        method: 'POST',
        body: JSON.stringify({
            description: desc,
            branch_name: branchName,
        }),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    if (resp.ok) {
        const data = await resp.json();
        return data.data;
    } else {
        return undefined;
    }
};

export const assignBranch = async (
    license: string,
    branchName: string,
    branchType: string,
    buildId: string,
    token?: string,
) => {
    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/branches/${branchName}/branch_type/${branchType}/build/${buildId}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

    if (resp.status !== 200) {
        throw new Error('failed to assign branch');
    }
};

export const getBranchList = async (license: string, token?: string): Promise<BranchData[]> => {
    const resp = await fetch(`${config.entityManagerURL}/game/${license}/branches`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    if (resp.status !== 200) {
        throw new Error('failed to get branches');
    }
    const data = await resp.json();
    // branches are order by name
    return data.data.branches;
};
